<template>
  <div class="replacement-items-container">
    <label>
      Replacements for Customer
    </label>

    <div v-for="(box, i) in replacementProductBoxes" :key="i" class="product-box">
      <div v-if="isCancelled(box)">
        <div>
          <span class="title">Box ID</span>
          <span class="description bold">{{ box.internalBoxId }}</span>
        </div>
        <div>
          <span class="title">Description</span>
          <span class="description">{{ box.internalDescription }}</span>
        </div>
        <div>
          <span class="title">Cost</span>
          <span class="description">${{ box.cost }} /each</span>
        </div>
        <div>
          <span class="title">Quantity</span>
          <span class="description">{{ (box.quantity || 1) * (box.orderItemQuantity || 1) }}</span>
        </div>
        <div v-if="box.supplier">
          <span class="title">Supplier</span>
          <span class="description">{{ box.supplier.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IClaimReplacementProductBox } from '@/types';

export default defineComponent({
  name: 'ReplacementItemList',
  props: {
    replacementProductBoxes: Array as PropType<IClaimReplacementProductBox[]>,
  },
  emits: ['input'],
  setup() {
    function isCancelled(box: any) {
      return !box.orderStatus || !box.orderStatus.includes('CANCEL');
    }

    return { isCancelled };
  },
});
</script>

<style lang="scss" scoped>
.replacement-items-container {
  label {
    font-weight: bold;
    font-size: var(--font-size-12);
    color: var(--grey-ultra-dark);
    line-height: 1;
  }
  .bold {
    font-weight: bold;
  }
  .product-box {
    font-size: 14px;
    color: #666;
    padding-left: 16px;
    line-height: 20px;
    border-left: 2px solid #ccc;
    margin: 12px 0;

    .title {
      width: 140px;
      display: inline-block;
      vertical-align: top;
    }
    .description {
      width: calc(100% - 140px);
      display: inline-block;
    }
  }
}
</style>
